export default __webpack_public_path__ + "static/media/left.613f8780.svg";